export default __webpack_public_path__ + "static/brcc-after-image-87a6228a4091f9b4c39c7a2ef3ffbb13.avif";